import { Axios } from 'axios';


export class S3UploadServiceProps {
  axios!: Axios
}

export class S3UploadService {
  axios!: Axios;

  constructor(props: S3UploadServiceProps) {
    this.axios = props.axios;
  }

  async upload(url: string, file: File) {
    return this.axios.put(url, file, {
      headers: {
        'Content-Type': file.type,
      },
    });
  }
}
